<template>
	<div class="wrapperddiv">
	<!-- 卡片试图区域 -->
	<el-card>
		<div slot="header" class="clearfix">
			<span>用户留痕查询日志</span>
		</div>
	 
		
		<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
		  <el-tab-pane label="海运整箱查询日志" name="first">
			  <!-- 搜索与添加区域 -->
			  		<el-row :gutter="20" style="padding: 20px 0 20px 0;">
			  			<el-col :span="8">
			  				<el-input 
			  				placeholder="请输入内容"
			  				v-model="queryInfo.query"
			  				clearable
			  				@input="changeValue"
			  				>
			  				    <el-button 
			  					slot="append" 
			  					icon="el-icon-search"
			  					@click="getLogList"
			  					></el-button>
			  				  </el-input>
			  				</el-col>
			  				<el-col :span="4">
			  					<el-button type="text" style="color: black;">筛选时间:</el-button>
			  				</el-col>
			  				<el-col :span="4" style="margin-left: -140px;">
			  					<el-date-picker
			  				      v-model="queryInfo.value2"
			  				      type="datetimerange"
			  				      :picker-options="pickerOptions"
			  				      range-separator="至"
			  				      start-placeholder="开始日期"
			  				      end-placeholder="结束日期"
			  				      align="right"
			  					  unlink-panels
			  				     :clearable="false"
			  					  >
			  				    </el-date-picker>
			  				</el-col>
			  		</el-row>
			  <!-- 日志列表区域 -->
			   <el-table
			        :data="loglist"
			  	  border
			  	  stripe>
			  	  <el-table-column
			  	    type="index"
			  	   >
			  	  </el-table-column>
			  	  <el-table-column
			  	    prop="pol"
			  	    label="查询的起运港"
			  	  				>
			  	  </el-table-column>
			  	  <el-table-column
			  	    prop="pod"
			  	    label="查询的目的港"
			  	  				>
			  	  </el-table-column>
			  	  <el-table-column
			  	    prop="carrier"
			  	    label="查询的船公司"
			  	  				>
			  	  </el-table-column>
			  	  <el-table-column
			  	     prop="operate_time"
			  	     label="操作时间"
			  		 width="140px"
			  		 >
			  		 <template slot-scope="scope">
			  			 {{scope.row.operate_time | fmtdate}}
			  		 </template>
			  	   </el-table-column>
			  	   <el-table-column
			  	     prop="username"
			  	     label="操作人员">
			  	   </el-table-column>
				   <el-table-column
				     prop="phone"
				     label="联系号码">
				   </el-table-column>
				   <el-table-column
				     prop="email"
				     label="邮箱">
				   </el-table-column>
					 <el-table-column
					   prop="company"
					   label="所属公司">
					 </el-table-column>
			      </el-table>
			  <!-- 分页区域 -->
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="queryInfo.pagenum"
			        :page-sizes="[1, 2, 5, 10]"
			        :page-size="queryInfo.pagesize"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  
		  </el-tab-pane>
		  <el-tab-pane label="海运拼箱查询日志" name="second">
			  <el-row :gutter="20" style="padding: 20px 0 20px 0;">
			  	<el-col :span="8">
			  		<el-input 
			  		placeholder="请输入内容"
			  		v-model="queryLclInfo.query"
			  		clearable
			  		@input="changeLclValue"
			  		>
			  		    <el-button 
			  			slot="append" 
			  			icon="el-icon-search"
			  			@click="getLclLogList"
			  			></el-button>
			  		  </el-input>
			  		</el-col>
			  		<el-col :span="4">
			  			<el-button type="text" style="color: black;">筛选时间:</el-button>
			  		</el-col>
			  		<el-col :span="4" style="margin-left: -140px;">
			  			<el-date-picker
			  		      v-model="queryLclInfo.value2"
			  		      type="datetimerange"
			  		      :picker-options="pickerOptions"
			  		      range-separator="至"
			  		      start-placeholder="开始日期"
			  		      end-placeholder="结束日期"
			  		      align="right"
			  			  unlink-panels
			  		     :clearable="false"
			  			  >
			  		    </el-date-picker>
			  		</el-col>
			  </el-row>
			  <!-- 日志列表区域 -->
			   <el-table
			      :data="logLclList"
			  	  border
			  	  stripe>
			  	  <el-table-column
			  	    type="index"
			  	   >
			  	  </el-table-column>
			  	  <el-table-column
			  	    prop="pol"
			  	    label="查询的起运港"
			  	  				>
			  	  </el-table-column>
			  	  <el-table-column
			  	    prop="pod"
			  	    label="查询的目的港"
			  	  				>
			  	  </el-table-column>
			  	<!--  <el-table-column
			  	    prop="country"
			  	    label="查询的国家"
			  	  				>
			  	  </el-table-column> -->
			  	  <el-table-column
			  	     prop="operate_time"
			  	     label="操作时间"
			  		 width="140px"
			  		 >
			  		 <template slot-scope="scope">
			  			 {{scope.row.operate_time | fmtdate}}
			  		 </template>
			  	   </el-table-column>
			  	   <el-table-column
			  	     prop="username"
			  	     label="操作人员">
			  	   </el-table-column>
				   <el-table-column
				     prop="phone"
				     label="联系号码">
				   </el-table-column>
				   <el-table-column
				     prop="email"
				     label="邮箱">
				   </el-table-column>
				   <el-table-column
				     prop="company"
				     label="所属公司">
				   </el-table-column>
			      </el-table>
			  <!-- 分页区域 -->
			  <el-pagination
			        @size-change="handleSizeLclChange"
			        @current-change="handleCurrentLclChange"
			        :current-page="queryLclInfo.pagenum"
			        :page-sizes="[1, 2, 5, 10]"
			        :page-size="queryLclInfo.pagesize"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="lcltotal">
			      </el-pagination>
		  </el-tab-pane>
		  <el-tab-pane label="空运查询日志" name="three">
				<el-row :gutter="20" style="padding: 20px 0 20px 0;">
					<el-col :span="8">
						<el-input 
						placeholder="请输入内容"
						v-model="queryByAirInfo.query"
						clearable
						@input="changeByAirValue"
						>
						    <el-button 
							slot="append" 
							icon="el-icon-search"
							@click="getByAirLogList"
							></el-button>
						  </el-input>
						</el-col>
						<el-col :span="4">
							<el-button type="text" style="color: black;">筛选时间:</el-button>
						</el-col>
						<el-col :span="4" style="margin-left: -140px;">
							<el-date-picker
						      v-model="queryByAirInfo.value2"
						      type="datetimerange"
						      :picker-options="pickerOptions"
						      range-separator="至"
						      start-placeholder="开始日期"
						      end-placeholder="结束日期"
						      align="right"
							  unlink-panels
						     :clearable="false"
							  >
						    </el-date-picker>
						</el-col>
				</el-row>
				<!-- 日志列表区域 -->
				 <el-table
				    :data="logByAirList"
					  border
					  stripe>
					  <el-table-column
					    type="index"
					   >
					  </el-table-column>
					  <el-table-column
					    prop="pol"
					    label="查询的起运港"
					  				>
					  </el-table-column>
					  <el-table-column
					    prop="pod"
					    label="查询的目的港"
					  				>
					  </el-table-column>
					  <el-table-column
					    prop="carrier"
					    label="查询的航空公司"
					  				>
					  </el-table-column>
					  <el-table-column
					     prop="operate_time"
					     label="操作时间"
						 width="140px"
						 >
						 <template slot-scope="scope">
							 {{scope.row.operate_time | fmtdate}}
						 </template>
					   </el-table-column>
					   <el-table-column
					     prop="username"
					     label="操作人员">
					   </el-table-column>
				   <el-table-column
				     prop="phone"
				     label="联系号码">
				   </el-table-column>
				   <el-table-column
				     prop="email"
				     label="邮箱">
				   </el-table-column>
				   <el-table-column
				     prop="company"
				     label="所属公司">
				   </el-table-column>
				    </el-table>
				<!-- 分页区域 -->
				<el-pagination
				      @size-change="handleSizeByAirChange"
				      @current-change="handleCurrentByAirChange"
				      :current-page="queryByAirInfo.pagenum"
				      :page-sizes="[1, 2, 5, 10]"
				      :page-size="queryByAirInfo.pagesize"
				      layout="total, sizes, prev, pager, next, jumper"
				      :total="ByAirtotal">
				    </el-pagination>
			</el-tab-pane>
		  <el-tab-pane label="铁路查询日志" name="four">
				<el-row :gutter="20" style="padding: 20px 0 20px 0;">
					<el-col :span="8">
						<el-input 
						placeholder="请输入内容"
						v-model="queryRailroadInfo.query"
						clearable
						@input="changeRailroadValue"
						>
						    <el-button 
							slot="append" 
							icon="el-icon-search"
							@click="getRailroadLogList"
							></el-button>
						  </el-input>
						</el-col>
						<el-col :span="4">
							<el-button type="text" style="color: black;">筛选时间:</el-button>
						</el-col>
						<el-col :span="4" style="margin-left: -140px;">
							<el-date-picker
						      v-model="queryRailroadInfo.value2"
						      type="datetimerange"
						      :picker-options="pickerOptions"
						      range-separator="至"
						      start-placeholder="开始日期"
						      end-placeholder="结束日期"
						      align="right"
							  unlink-panels
						     :clearable="false"
							  >
						    </el-date-picker>
						</el-col>
				</el-row>
				<!-- 日志列表区域 -->
				 <el-table
				    :data="logRailroadList"
					  border
					  stripe>
					  <el-table-column
					    type="index"
					   >
					  </el-table-column>
					  <el-table-column
					    prop="pol"
					    label="查询的起运港"
					  				>
					  </el-table-column>
					  <el-table-column
					    prop="pod"
					    label="查询的目的港"
					  				>
					  </el-table-column>
					  <el-table-column
					     prop="operate_time"
					     label="操作时间"
						 width="140px"
						 >
						 <template slot-scope="scope">
							 {{scope.row.operate_time | fmtdate}}
						 </template>
					   </el-table-column>
					   <el-table-column
					     prop="username"
					     label="操作人员">
					   </el-table-column>
								   <el-table-column
								     prop="phone"
								     label="联系号码">
								   </el-table-column>
								   <el-table-column
								     prop="email"
								     label="邮箱">
								   </el-table-column>
								   <el-table-column
								     prop="company"
								     label="所属公司">
								   </el-table-column>
				    </el-table>
				<!-- 分页区域 -->
				<el-pagination
				      @size-change="handleSizeRailroadChange"
				      @current-change="handleCurrentRailroadChange"
				      :current-page="queryRailroadInfo.pagenum"
				      :page-sizes="[1, 2, 5, 10]"
				      :page-size="queryRailroadInfo.pagesize"
				      layout="total, sizes, prev, pager, next, jumper"
				      :total="Railroadtotal">
				    </el-pagination>
			</el-tab-pane>
			
			
			
			
			
		  <el-tab-pane label="内陆拖车查询日志" name="five"> 
			  <el-row :gutter="20" style="padding: 20px 0 20px 0;">
			  	<el-col :span="8">
			  		<el-input 
			  		placeholder="请输入内容"
			  		v-model="queryTrailerInfo.query"
			  		clearable
			  		@input="changeTrailerValue"
			  		>
			  		    <el-button 
			  			slot="append" 
			  			icon="el-icon-search"
			  			@click="getTrailerLogList"
			  			></el-button>
			  		  </el-input>
			  		</el-col>
			  		<el-col :span="4">
			  			<el-button type="text" style="color: black;">筛选时间:</el-button>
			  		</el-col>
			  		<el-col :span="4" style="margin-left: -140px;">
			  			<el-date-picker
			  		      v-model="queryTrailerInfo.value2"
			  		      type="datetimerange"
			  		      :picker-options="pickerOptions"
			  		      range-separator="至"
			  		      start-placeholder="开始日期"
			  		      end-placeholder="结束日期"
			  		      align="right"
			  			  unlink-panels
			  		     :clearable="false"
			  			  >
			  		    </el-date-picker>
			  		</el-col>
			  </el-row>
			  <!-- 日志列表区域 -->
			   <el-table
			      :data="logTrailerList"
			  	  border
			  	  stripe>
			  	  <el-table-column
			  	    type="index"
			  	   >
			  	  </el-table-column>
			  	  <el-table-column
			  	    prop="dock"
			  	    label="查询的港区"
			  	  				>
			  	  </el-table-column>
			  	  <el-table-column
			  	    prop="trailer_door_point"
			  	    label="查询的门点地址"
			  	  				>
			  	  </el-table-column>
			  	  <el-table-column
			  	     prop="operate_time"
			  	     label="操作时间"
			  		 width="140px"
			  		 >
			  		 <template slot-scope="scope">
			  			 {{scope.row.operate_time | fmtdate}}
			  		 </template>
			  	   </el-table-column>
			  	   <el-table-column
			  	     prop="username"
			  	     label="操作人员">
			  	   </el-table-column>
			  				   <el-table-column
			  				     prop="phone"
			  				     label="联系号码">
			  				   </el-table-column>
			  				   <el-table-column
			  				     prop="email"
			  				     label="邮箱">
			  				   </el-table-column>
							   <el-table-column
							     prop="company"
							     label="所属公司">
							   </el-table-column>
			      </el-table>
			  <!-- 分页区域 -->
			  <el-pagination
			        @size-change="handleSizeTrailerChange"
			        @current-change="handleCurrentTrailerChange"
			        :current-page="queryTrailerInfo.pagenum"
			        :page-sizes="[1, 2, 5, 10]"
			        :page-size="queryTrailerInfo.pagesize"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="trailertotal">
			      </el-pagination>
		  </el-tab-pane>
			
			
			<el-tab-pane label="国际快递查询日志" name="six">
			  <el-row :gutter="20" style="padding: 20px 0 20px 0;">
			  	<el-col :span="8">
			  		<el-input 
			  		placeholder="请输入内容"
			  		v-model="queryExpressInfo.query"
			  		clearable
			  		@input="changeExpressValue"
			  		>
			  		    <el-button 
			  			slot="append" 
			  			icon="el-icon-search"
			  			@click="getExpressLogList"
			  			></el-button>
			  		  </el-input>
			  		</el-col>
			  		<el-col :span="4">
			  			<el-button type="text" style="color: black;">筛选时间:</el-button>
			  		</el-col>
			  		<el-col :span="4" style="margin-left: -140px;">
			  			<el-date-picker
			  		      v-model="queryExpressInfo.value2"
			  		      type="datetimerange"
			  		      :picker-options="pickerOptions"
			  		      range-separator="至"
			  		      start-placeholder="开始日期"
			  		      end-placeholder="结束日期"
			  		      align="right"
			  			  unlink-panels
			  		     :clearable="false"
			  			  >
			  		    </el-date-picker>
			  		</el-col>
			  </el-row>
			  <!-- 日志列表区域 -->
			   <el-table
			      :data="logExpressList"
			  	  border
			  	  stripe>
			  	  <el-table-column
			  	    type="index"
			  	   >
			  	  </el-table-column>
			  	  <el-table-column
			  	    prop="destination"
			  	    label="目的地"
			  	  				>
			  	  </el-table-column>
			  	  <el-table-column
			  	    prop="weight"
			  	    label="重量/KG"
			  	  				>
			  	  </el-table-column>
			  	  <el-table-column
			  	     prop="operate_time"
			  	     label="操作时间"
			  		 width="140px"
			  		 >
			  		 <template slot-scope="scope">
			  			 {{scope.row.operate_time | fmtdate}}
			  		 </template>
			  	   </el-table-column>
			  	   <el-table-column
			  	     prop="username"
			  	     label="操作人员">
			  	   </el-table-column>
			  				   <el-table-column
			  				     prop="phone"
			  				     label="联系号码">
			  				   </el-table-column>
			  				   <el-table-column
			  				     prop="email"
			  				     label="邮箱">
			  				   </el-table-column>
							   <el-table-column
							     prop="company"
							     label="所属公司">
							   </el-table-column>
			      </el-table>
			  <!-- 分页区域 -->
			  <el-pagination
			        @size-change="handleSizeExpressChange"
			        @current-change="handleCurrentExpressChange"
			        :current-page="queryExpressInfo.pagenum"
			        :page-sizes="[1, 2, 5, 10]"
			        :page-size="queryExpressInfo.pagesize"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="Expresstotal">
			      </el-pagination>
			</el-tab-pane>
			
			
			
			
			
			
			
			
		</el-tabs>
		
		
	
	</el-card>
		</div>
</template>

<script>
	export default{
		data(){
			return{
				activeName: 'first',
				//延时器，防抖，防止用户频繁请求
				timer:null,
				 pickerOptions: {
				          shortcuts: [{
				            text: '最近一周',
				            onClick(picker) {
				              const end = new Date();
				              const start = new Date();
				              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				              picker.$emit('pick', [start, end]);
				            }
				          }, {
				            text: '最近一个月',
				            onClick(picker) {
				              const end = new Date();
				              const start = new Date();
				              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				              picker.$emit('pick', [start, end]);
				            }
				          }, {
				            text: '最近三个月',
				            onClick(picker) {
				              const end = new Date();
				              const start = new Date();
				              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
				              picker.$emit('pick', [start, end]);
				            }
				          }]
				        },
						//value2: '',
				//获取列表的参数对象
				queryInfo:{
					query:'',
					//默认选中日期，一整年
					value2:[new Date(new Date()- 3600 * 1000 * 24 * 365),new Date()],
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:10
				},
				loglist:[],
				total:0,
				//海运拼箱
				logLclList:[],
				queryLclInfo:{
					query:'',
					//默认选中日期，一整年
					value2:[new Date(new Date()- 3600 * 1000 * 24 * 365),new Date()],
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:10
				},
				lcltotal:0,
				//内陆拖车
				logTrailerList:[],
				queryTrailerInfo:{
					query:'',
					//默认选中日期，一整年
					value2:[new Date(new Date()- 3600 * 1000 * 24 * 365),new Date()],
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:10
				},
				trailertotal:0,
				//空运
				logByAirList:[],
				queryByAirInfo:{
					query:'',
					//默认选中日期，一整年
					value2:[new Date(new Date()- 3600 * 1000 * 24 * 365),new Date()],
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:10
				},
				ByAirtotal:0,
				
				//铁路
				logRailroadList:[],
				queryRailroadInfo:{
					query:'',
					//默认选中日期，一整年
					value2:[new Date(new Date()- 3600 * 1000 * 24 * 365),new Date()],
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:10
				},
				Railroadtotal:0,
				
				//国际铁路
				logExpressList:[],
				queryExpressInfo:{
					query:'',
					//默认选中日期，一整年
					value2:[new Date(new Date()- 3600 * 1000 * 24 * 365),new Date()],
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:10
				},
				Expresstotal:0,
				
			}
		},
		created(){
			this.getLogList()
		
		},
		methods:{
			
			//****查询*******
			changeValue(e) {
					this.queryInfo.pagenum = 1
					clearTimeout(this.timer)
					        this.timer = setTimeout(()=>{
					        		this.queryInfo.query = e
					        		this.getLogList()
					        	},500)
			       },
				   
				   changeLclValue(e){
					this.queryLclInfo.pagenum = 1
					clearTimeout(this.timer)
					        this.timer = setTimeout(()=>{
					        		this.queryLclInfo.query = e
					        		this.getLclLogList()
					        	},500)   
				   },
				   changeTrailerValue(e){
					 this.queryTrailerInfo.pagenum = 1
					 clearTimeout(this.timer)
					         this.timer = setTimeout(()=>{
					         		this.queryTrailerInfo.query = e
					         		this.getTrailerLogList()
					         	},500)     
				   },
				   changeByAirValue(e){
				   					 this.queryByAirInfo.pagenum = 1
				   					 clearTimeout(this.timer)
				   					         this.timer = setTimeout(()=>{
				   					         		this.queryByAirInfo.query = e
				   					         		this.getByAirLogList()
				   					         	},500)     
				   },
				   
				   changeRailroadValue(e){
				   					 this.queryRailroadInfo.pagenum = 1
				   					 clearTimeout(this.timer)
				   					         this.timer = setTimeout(()=>{
				   					         		this.queryRailroadInfo.query = e
				   					         		this.getRailroadLogList()
				   					         	},500)     
				   },
				   changeExpressValue(e){
				   					 this.queryExpressInfo.pagenum = 1
				   					 clearTimeout(this.timer)
				   					         this.timer = setTimeout(()=>{
				   					         		this.queryExpressInfo.query = e
				   					         		this.getExpressLogList()
				   					         	},500)     
				   },
				   
				    handleClick(tab, event) {
				       if(this.activeName =='second'){
				       	  	this.getLclLogList()
				       } else if(this.activeName =='five'){
				       	  	this.getTrailerLogList()
				       } else if(this.activeName =='three'){
						   this.getByAirLogList()
					   } else if(this.activeName =='four'){
						   this.getRailroadLogList()
					   } else if(this.activeName =='six'){
						   this.getExpressLogList()
					   } 			
				         },
				   //海运整箱
			async getLogList(){
				const {data:res} = await this.$http.getFclLogsList({params:this.queryInfo})
				if (res.status !==0){
	             return this.$message.error('获取查询日志列表失败!')
				}
				this.loglist = res.data
				this.total = res.total
			},
			//监听pagesize改变的事件
			handleSizeChange(newSize){
				this.queryInfo.pagesize = newSize
				this.getLogList()
			},
			//监听页面值改变的事件
			handleCurrentChange(newPage){
				this.queryInfo.pagenum = newPage
				this.getLogList()
			},
			
			  //海运拼箱
			async getLclLogList(){
				const {data:res} = await this.$http.getLclLogsList({params:this.queryLclInfo})
				if (res.status !==0){
			     return this.$message.error('获取查询日志列表失败!')
				}
				this.logLclList = res.data
				this.lcltotal = res.total
			}, 
			handleSizeLclChange(newSize){
				this.queryLclInfo.pagesize = newSize
				this.getLclLogList()
			},
			handleCurrentLclChange(newPage){
				this.queryLclInfo.pagenum = newPage
				this.getLclLogList()
			},
			 
			 //内陆拖车
			 async getTrailerLogList(){
			 	const {data:res} = await this.$http.getTrailerLogsList({params:this.queryTrailerInfo})
			 	if (res.status !==0){
			      return this.$message.error('获取查询日志列表失败!')
			 	}
			 	this.logTrailerList = res.data
			 	this.trailertotal = res.total
			 }, 
			 handleSizeTrailerChange(newSize){
			 	this.queryTrailerInfo.pagesize = newSize
			 	this.getTrailerLogList()
			 },
			 handleCurrentTrailerChange(newPage){
			 	this.queryTrailerInfo.pagenum = newPage
			 	this.getTrailerLogList()
			 },
			 //空运
			 async getByAirLogList(){
			 	const {data:res} = await this.$http.getByAirLogsList({params:this.queryByAirInfo})
			 	if (res.status !==0){
			      return this.$message.error('获取查询日志列表失败!')
			 	}
			 	this.logByAirList = res.data
			 	this.ByAirtotal = res.total
			 }, 
			 handleSizeByAirChange(newSize){
			 	this.queryByAirInfo.pagesize = newSize
			 	this.getByAirLogList()
			 },
			 handleCurrentByAirChange(newPage){
			 	this.queryByAirInfo.pagenum = newPage
			 	this.getByAirLogList()
			 },
			 
			 //铁路
			 async getRailroadLogList(){
			 	const {data:res} = await this.$http.getRailroadList({params:this.queryRailroadInfo})
			 	if (res.status !==0){
			      return this.$message.error('获取查询日志列表失败!')
			 	}
			 	this.logRailroadList = res.data
			 	this.Railroadtotal = res.total
			 }, 
			 handleSizeRailroadChange(newSize){
			 	this.queryRailroadInfo.pagesize = newSize
			 	this.getRailroadLogList()
			 },
			 handleCurrentRailroadChange(newPage){
			 	this.queryRailroadInfo.pagenum = newPage
			 	this.getRailroadLogList()
			 },
			 
			 
			 //国际快递
			 async getExpressLogList(){
			 	const {data:res} = await this.$http.getExpressLogsList({params:this.queryExpressInfo})
			 	if (res.status !==0){
			      return this.$message.error('获取查询日志列表失败!')
			 	}
			 	this.logExpressList = res.data
			 	this.Expresstotal = res.total
			 }, 
			 handleSizeExpressChange(newSize){
			 	this.queryExpressInfo.pagesize = newSize
			 	this.getExpressLogList()
			 },
			 handleCurrentExpressChange(newPage){
			 	this.queryExpressInfo.pagenum = newPage
			 	this.getExpressLogList()
			 },
			    
		}
	}
</script>

<style lang="less" scoped>
	@media screen and (min-width: 1280px) {
		.wrapperddiv{
			height: 100vh;
			width: 100%;
			display:inline-block;
		} 
	}
	
	//手机端
	@media screen and (max-width: 1280px) {
		.wrapperddiv{
			height: 100%;
			width: 100%;
			display:inline-block;
		} 
	}
</style>
